'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const SortExtensions=require('../../../../../dist-es6/client/extensions/sortExtensions');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DashboardListDirective=function(_BaseControllerBacked){_inherits(DashboardListDirective,_BaseControllerBacked);function DashboardListDirective(){_classCallCheck(this,DashboardListDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DashboardListDirective,[{key:'objectBindings',get:function()
{
return[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'selectedGroupData',
'selectedNotificationType'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/dashboard/components/dashboardListView';
}},{key:'controller',get:function()

{
return DashboardListController;
}}]);return DashboardListDirective}(BaseControllerBackedDirective);let


DashboardListController=function(){
function DashboardListController(timeFormattingService){_classCallCheck(this,DashboardListController);
this._timeFormattingService=timeFormattingService;

this._sortByDescendingFatigueScore=SortExtensions(this.sortByFatigueScore).invert();

this.tableColumnDefinitions=[{
label:'Name',
defaultAscending:!0,
orderBy:['name'],
finalSort:[this._sortByDescendingFatigueScore],
columnClass:'name-column'},
{
label:'Alert',
isInitiallyActive:!0,
defaultAscending:!1,
orderBy:[this.sortByFatigueAlertType],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'deviation-column'},
{
label:'Fatigue',
defaultAscending:!1,
orderBy:[this.sortByFatigueScore],
finalSort:['name'],
columnClass:'fatigue-column'},
{
label:'Status',
defaultAscending:!0,
orderBy:['lastKnownDutyStatus'],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'duty-status-column'},
{
label:'Location',
defaultAscending:!0,
orderBy:['lastKnownLocationDescription'],
finalSort:[this._sortByDescendingFatigueScore,'name'],
columnClass:'last-location-column'},
{

columnClass:'filler-column'}];

}_createClass(DashboardListController,[{key:'timeFormattingService',get:function()

{
return this._timeFormattingService;
}}]);return DashboardListController}();


module.exports=DashboardListDirective;
//# sourceMappingURL=dashboardListDirective.js.map
